import axios from 'axios';
// var baseURL='https://www.scxjc.club'
var baseURL = ''
axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        // if (config.url.indexOf('downloadzip') >= 0) {
        // if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token                      
        // 	config.headers.Authorization = `${token}`;   
        // } else {
        // 	//未登录
        // 	window.location.hash = "/login";
        // }
        // } 
        return config;
    },
    err => {
        return Promise.reject(err);
    });
axios.interceptors.response.use(function(response) {
    // console.log(response.headers)
    // IE 8-9 
    if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
        try {
            // eslint-disable-next-line no-param-reassign
            response.data = JSON.parse(response.request.responseText);
        } catch (e) {
            // ignored
        }
    }
    // 对响应数据做点什么
    if (response.data.code == 401) {
        // window.location.hash = "/login";
        // window.location.hash = "/";
    }
    if (response.data.code == 305) {
        // window.location.hash = "/";
    }
    return response;
}, function(error) {
    // 对响应错误做点什么
    if (error.request.status == 403) {
        // window.location.hash = "/login";
        window.location.hash = "/";
    }
    // console.log(Object.getOwnPropertyNames(error))
    // console.log(error.request,error.message)
    return Promise.reject(error);
});
export default {
    //登录
    login: params => {
        return axios.post(`${baseURL}/api/account/login`, params);
    },
    logout: params => {
        return axios.post(`${baseURL}/api/account/logout`, params);
    },
    reset: params => {
        return axios.put(`${baseURL}/api/account/pwd/reset`, params);
    },
    // 全局账号信息
    getAccountInfo: params => {
        return axios.get(`${baseURL}/api/account/info`)
    },
    // 验证码
    getCode: params => {
        return axios.get(`${baseURL}/api/account/imgcode`)
    },
    // 账号
    getUserList: params => {
        return axios.get(`${baseURL}/api/admin/user/list`, { params: params })
    },
    getAllSysUserList: params => {
        return axios.get(`${baseURL}/api/admin/user/all`, { params: params })
    },
    getUserinfoList: params => {
        return axios.get(`${baseURL}/api/admin/userinfo/list`, { params: params })
    },
    // 获取用户待选期刊列表
    getUserJournals: () => {
        return axios.get(`${baseURL}/api/admin/user/journals`)
    },
    // 获取用户待选角色列表
    getUserRoles: () => {
        return axios.get(`${baseURL}/api/admin/user/roles`)
    },

    //新增管理员
    addUser: params => {
        return axios.post(`${baseURL}/api/admin/user`, params);
    },
    // 修改管理员
    editUser: params => {
        return axios.put(`${baseURL}/api/admin/user`, params);
    },
    // 删除管理员
    delUser: params => {
        return axios.delete(`${baseURL}/api/admin/user`, { params: params });
    },
    // 删除管理员
    getUserInfo: params => {
        return axios.get(`${baseURL}/api/admin/user`, { params: params });
    },
    // 获取数据
    getPlayerRecord: params => {
        return axios.get(`${baseURL}/api/admin/player/record/list`, { params: params });
    },
    addRecord: params => {
        return axios.post(`${baseURL}/api/admin/player/record`, params);
    },
    getRecordInfo: params => {
        return axios.get(`${baseURL}/api/admin/player/record`, { params: params });
    },
    editRecord: params => {
        return axios.put(`${baseURL}/api/admin/player/record`, params);
    },
    delRecord: params => {
        return axios.delete(`${baseURL}/api/admin/player/record`, { params: params });
    },
    downloadRecords: params => {
        return axios.get(`${baseURL}/api/admin/player/record/download`, { params: params, responseType: "blob" })
    },
    // 比赛搜索列表
    getMatchList: params => {
        return axios.get(`${baseURL}/api/admin/match/search`, { params: params })
    },
    // 选手列表
    getPlayerList: params => {
        return axios.get(`${baseURL}/api/admin/player/search`, { params: params })
    },
    // 分组列表
    getGroupList: params => {
        return axios.get(`${baseURL}/api/admin/match/group/search`, { params: params })
    },
    // 股票列表
    getStockSearchList: params => {
        return axios.get(`${baseURL}/api/admin/stock/search`, { params: params })
    },
    //获取所有模板列表
    getAllTemplateList: params => {
        return axios.get(`${baseURL}/api/admin/message/template/all`, { params: params })
    },
    // 新增角色
    addRole: params => {
        return axios.post(`${baseURL}/api/admin/role`, params);
    },
    // 修改角色
    editRole: params => {
        return axios.put(`${baseURL}/api/admin/role`, params);
    },
    delRole: params => {
        return axios.delete(`${baseURL}/api/admin/role`, { params: params });
    },
    // 获取角色列表
    getRoleList: params => {
        return axios.get(`${baseURL}/api/admin/role/list`, { params: params });
    },
    // 获取角色详情
    getRoleInfo: params => {
        return axios.get(`${baseURL}/api/admin/role`, { params: params });
    },
    // 选手列表
    getPlayers: params => {
        return axios.get(`${baseURL}/api/admin/player/list`, { params: params })
    },
    // 新增选手
    addPlayer: params => {
        return axios.post(`${baseURL}/api/admin/player`, params)
    },
    // 编辑选手
    updatePlayer: params => {
        return axios.put(`${baseURL}/api/admin/player`, params)
    },
    // 删除选手
    delPlayer: params => {
        return axios.delete(`${baseURL}/api/admin/player`, { params: params })
    },
    // 选手详情
    getPlayerInfo: params => {
        return axios.get(`${baseURL}/api/admin/player`, { params: params })
    },
    // 用户搜索
    getUserSearch: params => {
        return axios.get(`${baseURL}/api/admin/user/search`, { params: params })
    },
    // 赛事列表
    getMatchs: params => {
        return axios.get(`${baseURL}/api/admin/match/list`, { params: params })
    },
    // 分组管理
    getGroups: params => {
        return axios.get(`${baseURL}/api/admin/match/group/list`, { params: params })
    },
    // 新增赛事
    addMatch: params => {
        return axios.post(`${baseURL}/api/admin/match`, params);
    },
    // 修改赛事
    updateMatch: params => {
        return axios.put(`${baseURL}/api/admin/match`, params);
    },
    delMatch: params => {
        return axios.delete(`${baseURL}/api/admin/match`, { params: params })
    },
    // 新增分组
    addGroup: params => {
        return axios.post(`${baseURL}/api/admin/match/group`, params);
    },
    // 修改分组
    updateGroup: params => {
        return axios.put(`${baseURL}/api/admin/match/group`, params);
    },
    delGroup: params => {
        return axios.delete(`${baseURL}/api/admin/match/group`, { params: params });
    },
    // 快速新增选手
    fastSavePlayer: params => {
        return axios.post(`${baseURL}/api/admin/player/fast`, params);
    },
    // 自动填充数据
    autoCompleteData: params => {
        return axios.post(`${baseURL}/api/admin/player/autorecord`, params);
    },
    // 文章
    addArticle: params => {
        return axios.post(`${baseURL}/api/admin/article`, params);
    },
    editArticle: params => {
        return axios.put(`${baseURL}/api/admin/article`, params);
    },
    delArticle: params => {
        return axios.delete(`${baseURL}/api/admin/article`, { params: params });
    },
    getArticleById: params => {
        return axios.get(`${baseURL}/api/admin/article`, { params: params })
    },
    getArticleList: params => {
        return axios.get(`${baseURL}/api/admin/article/list`, { params: params })
    },
    // 更新排名
    updateRank: params => {
        return axios.get(`${baseURL}/api/admin/flushrank`, { params: params })
    },
    updateComment: params => {
        return axios.put(`${baseURL}/api/admin/player/record/comment`, params);
    },
    // 股票
    getStockList: params => {
        return axios.get(`${baseURL}/api/admin/stock/list`, { params: params })
    },
    getStockInfo: params => {
        return axios.get(`${baseURL}/api/admin/stock`, { params: params })
    },
    updateStock: params => {
        return axios.put(`${baseURL}/api/admin/stock`, params)
    },
    addStock: params => {
        return axios.post(`${baseURL}/api/admin/stock`, params)
    },
    delStock: params => {
        return axios.delete(`${baseURL}/api/admin/stock`, { params: params });
    },
    // 重置选手初始资金
    resetInitFund: params => {
        return axios.post(`${baseURL}/api/admin/reset/initfund`, params)
    },
    // 订单列表
    getSignupList: params => {
        return axios.get(`${baseURL}/api/admin/signup/list`, { params: params })
    },
    // 顽主咨询
    getWanzhuConsultList: params => {
        return axios.get(`${baseURL}/api/admin/consult/list`, { params: params })
    },
    // 顽主咨询详情
    getWanzhuConsultDetail: params => {
        return axios.get(`${baseURL}/api/admin/consult`, { params: params })
    },
    // 回复顽主咨询
    replyConsult: params => {
        return axios.post(`${baseURL}/api/admin/consult/reply`, params)
    },
    // 删除咨询
    delConsult: params => {
        return axios.delete(`${baseURL}/api/admin/consult`, { params: params });
    },
    // 订单详情
    getSignupOrderDetail: params => {
        return axios.get(`${baseURL}/api/admin/signup`, { params: params })
    },
    // 修改订单
    editSignupOrder: params => {
        return axios.put(`${baseURL}/api/admin/signup`, params)
    },
    // 删除订单
    delSignupOrder: params => {
        return axios.delete(`${baseURL}/api/admin/signup`, { params: params });
    },
    // 股票评论
    getStockCommentsList: params => {
        return axios.get(`${baseURL}/api/admin/stock/comments/list`, { params: params })
    },
    // 作业评论
    getRecordCommentsList: params => {
        return axios.get(`${baseURL}/api/admin/record/comments/list`, { params: params })
    },
    // 更新选手类型和手机号
    savePlayerTypePhone: params => {
        return axios.put(`${baseURL}/api/admin/player/type`, params)
    },
    // 置顶
    commentsTop: params => {
        return axios.put(`${baseURL}/api/admin/comments/top`, params)
    },
    // 评论拉黑
    commentsBlack: params => {
        return axios.put(`${baseURL}/api/admin/comments/black`, params)
    },
    // 删除评论
    delComments: params => {
        return axios.delete(`${baseURL}/api/admin/comments`, { params: params });
    },
    // 修改选手角色
    updatePlayerRole: params => {
        return axios.put(`${baseURL}/api/admin/player/role`, params)
    },
    // 关联老用户
    relationOld: params => {
        return axios.put(`${baseURL}/api/admin/user/relationold`, params)
    },
    // 获取无openid的老用户
    getopenidmiss: params => {
        return axios.get(`${baseURL}/api/admin/user/openidmiss`, { params: params })
    },
    // 老用户处理
    saveOldUser: params => {
        return axios.put(`${baseURL}/api/admin/signup/olduser`, params)
    },
    // 资金出入
    getFundInOut: params => {
        return axios.get(`${baseURL}/api/admin/user/fundinout`, { params: params })
    },
    // 删除资金出入
    delFundInOut: params => {
        return axios.delete(`${baseURL}/api/admin/user/fundinout`, { params: params })
    },
    // 资金出入列表
    getFundInOutList: params => {
        return axios.get(`${baseURL}/api/admin/user/fundinout/list`, { params: params })
    },
    //计算出入资金 
    caculateFundInOut: params => {
        return axios.get(`${baseURL}/api/admin/user/fundinout/caculate`, { params: params })
    },

    // 咨询详情
    getConsultDetail: params => {
        return axios.get(`${baseURL}/api/admin/user/consult/detail`, { params: params })
    },
    //新增百科分类 
    addBaikeCategory: params => {
        return axios.post(`${baseURL}/api/admin/baike/category`, params)
    },
    // 修改百科分类
    editBaikeCategory: params => {
        return axios.put(`${baseURL}/api/admin/baike/category`, params)
    },
    // 删除百科分类
    delBaikeCategory: params => {
        return axios.delete(`${baseURL}/api/admin/baike/category`, { params: params })
    },
    // 百科词条分类
    getBaikeCategoryDetail: params => {
        return axios.get(`${baseURL}/api/admin/baike/category`, { params: params })
    },
    // 百科分类列表
    getBaikeCategoryList: params => {
        return axios.get(`${baseURL}/api/admin/baike/category/list`, { params: params })
    },
    // 百科词条详情
    getBaikeDetail: params => {
        return axios.get(`${baseURL}/api/admin/baike/detail`, { params: params })
    },
    //新增百科词条 
    addBaikeDetail: params => {
        return axios.post(`${baseURL}/api/admin/baike/detail`, params)
    },
    // 修改百科词条
    editBaikeDetail: params => {
        return axios.put(`${baseURL}/api/admin/baike/detail`, params)
    },
    // 删除百科词条
    delBaikeDetail: params => {
        return axios.delete(`${baseURL}/api/admin/baike/detail`, { params: params })
    },
    // 百科词条列表
    getBaikeDetailList: params => {
        return axios.get(`${baseURL}/api/admin/baike/detail/list`, { params: params })
    },
    // 文章推送
    pushArticle: params => {
        return axios.post(`${baseURL}/api/admin/article/push`, params)
    },
    // 版本列表
    getVersionList: params => {
        return axios.get(`${baseURL}/api/admin/version/list`, { params: params })
    },
    //退款
    refundSignupOrder: params => {
        return axios.post(`${baseURL}/api/admin/wxpay/refund`, params)
    },
    // 牛人点评
    getStockNBCommentsList: params => {
        return axios.get(`${baseURL}/api/admin/stock/nbcomments/list`, { params: params })
    },
    delStockNBComments: params => {
        return axios.delete(`${baseURL}/api/admin/stock/nbcomments`, { params: params })
    },
    getStockNBCommentsInfo: params => {
        return axios.get(`${baseURL}/api/admin/stock/nbcomments`, { params: params })
    },
    addStockNBComments: params => {
        return axios.post(`${baseURL}/api/admin/stock/nbcomments`, params)
    },
    editStockNBComments: params => {
        return axios.put(`${baseURL}/api/admin/stock/nbcomments`, params)
    },
    // 名人堂
    getFamousUserList: params => {
        return axios.get(`${baseURL}/api/admin/user/famous/list`, { params: params })
    },
    delFamousUser: params => {
        return axios.delete(`${baseURL}/api/admin/user/famous`, { params: params })
    },
    getFamousUserInfo: params => {
        return axios.get(`${baseURL}/api/admin/user/famous`, { params: params })
    },
    addFamousUser: params => {
        return axios.post(`${baseURL}/api/admin/user/famous`, params)
    },
    editFamousUser: params => {
        return axios.put(`${baseURL}/api/admin/user/famous`, params)
    },
    getArticleSearchList: params => {
        return axios.get(`${baseURL}/api/admin/article/search`, { params: params })
    },
    // 版本管理
    delVersion: params => {
        return axios.delete(`${baseURL}/api/admin/version`, { params: params })
    },
    getVersionInfo: params => {
        return axios.get(`${baseURL}/api/admin/version`, { params: params })
    },
    addVersion: params => {
        return axios.post(`${baseURL}/api/admin/version`, params)
    },
    editVersion: params => {
        return axios.put(`${baseURL}/api/admin/version`, params)
    },
    // 百科置顶
    baikeDetailTop: params => {
        return axios.put(`${baseURL}/api/admin/baike/detail/top`, params)
    },
    //文章抓取
    getSpiderArticle: params => {
        return axios.get(`${baseURL}/api/admin/article/spider`, { params: params })
    },

    //下载排名数据图片
    getDataPic: params => {
        return axios.get(`${baseURL}/api/admin/player/record/downloadimage`, { params: params,responseType: "blob" })
    },
    // 下载top3排名数据
    downloadTop3Imgs: params => {
        return axios.get(`${baseURL}/api/admin/player/record/download/top3img`, { params: params,responseType: "blob" })
    },
    updateStockUserNum: params => {
        return axios.post(`${baseURL}/api/admin/stock/updateUserStock`, params)
    },

}